import React, { Component } from 'react';
import moment from 'moment-timezone';
import timezones from '../helpers/timezone';
import i18n from '../helpers/i18n';
var Select = require('react-select').default;
import injectSheet from 'react-jss';
import filter from 'lodash/filter';
import { Typography, theme } from '@hiver/hiver-ui-kit';



class TimeZonePicker extends Component {

    constructor(props){
        super(props);
    }

    /**
     * generates timezone list 
     */
    getTimezoneList = () => {
        const _getTimeZoneName= (tzName) => {
            if (i18n !== void 0 && i18n[tzName]) {
            return i18n[tzName];
            }
        
            return tzName;
        };

        const _getOffsetToMinutes = (tz) => {
            return tz.offset ? moment.tz(tz.name).format('Z') : '';
        }

        const timezoneList = moment.tz.names()
            .filter(tz => {
                return timezones.push(tz)
            })
            .reduce((timeZoneObj, tz) => ([
                ...timeZoneObj, 
                { name: tz, offset: moment.tz(tz).utcOffset()}                
            ]), [])
            .sort((a, b) => {
                return a.offset - b.offset
            })
            .map(tz => ({
                value: tz.name,
                label: `(GMT${_getOffsetToMinutes(tz)}) ${_getTimeZoneName(tz.name)}`
            }));

        return timezoneList;
    }


    handleChange = (selectedOption) => {
        this.props.input.onChange(selectedOption.value);
    }

    render(){
        const timezoneList = this.getTimezoneList();
        const { input: { value }} = this.props;
        const selectedValue = value || "";
        const matchedValue = selectedValue.split(' ')[1] || selectedValue;             

        return(
        <Typography variant="body2" sx={{color: theme.palette.gray.black}}>
            <Select
                id="timeZonePicker"
                value={matchedValue}
                onChange={this.handleChange}
                options={timezoneList}
                searchable={true}
                clearable={false}
                name="timezone"
                wrapperStyle={style.tpStyle}
            />
        </Typography>
        );
        

    }

}

const style = {
    tpStyle: {
        width: '61%',
        marginRight: '45px'
    }
}
export default (injectSheet(style)(TimeZonePicker));



